import React, {useMemo} from 'react';
import {useSelector} from "react-redux";
import {useNoticesUIContext} from "./NoticesUIContext";
import {Card, CardBody, CardHeader, CardHeaderToolbar} from "../../../../../_metronic/_partials/controls";
import { HasCreateAccess, IsSuperUser} from "../../../../../_metronic/_helpers/AccessControlHelpers";
import {NoticesTable} from "./notices-table/NoticesTable";
import {NOTICE_MODEL} from "../../../../../_metronic/_helpers/AppModels";
import {NoticesFilter} from "./notices-filter/NoticesFilter";



export function NoticesCard(){
    const {user} = useSelector((state) => state.auth);
    
    const noticesUIContext = useNoticesUIContext();

    const noticesUIProps = useMemo(() => (
        {
            newNoticeButtonClick: noticesUIContext.newNoticeButtonClick
        }
    ), [noticesUIContext])
    
    
    return(
        <Card>
            <CardHeader title={"لیست اطلاعیه ها"}>
                {(HasCreateAccess(user, NOTICE_MODEL) || IsSuperUser(user)) && (
                    <CardHeaderToolbar>
                        <button
                            type={"button"}
                            className={"btn btn-primary"}
                            onClick={noticesUIProps.newNoticeButtonClick}>
                            ایجاد اطلاعیه
                        </button>

                    </CardHeaderToolbar>
                )}
            </CardHeader>
            <CardBody>
                <NoticesFilter/>
                <NoticesTable/>
            </CardBody>
        </Card>
    )
    
}